import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { _Api } from "Ecommerce/common/api";
import CrossIcon from "Ecommerce/template_three/assets/icons/CrossIcon";
import Spinner from "Ecommerce/common/Spinner";

export default function CartItemsNotify(props) {
    const { setIsopennotifycart, setisopencart, isopennotifycart } = props;
    const { t } = useTranslation();
    const [notifycartitems, setNotifycartitems] = useState([]);
    const [, setCheckoutItems] = useState([]);
    const [loading, setLoading] = useState(false)
    let localitem = localStorage.getItem('CartItems') ? JSON.parse(localStorage.getItem('CartItems')) : [];
    const navigate = useNavigate()


    const getcartItems = async () => {
        setLoading(true)
        let cartids = [];
        let details = [];
        let product = [];
        let postdata = {}
        if (localitem?.length) { product.push(localitem[localitem?.length - 1]) }
       

        details.push(
            {
                "id": product[0]?.id,
                "qty": product[0]?.qty,
                "diamond_id": product[0]?.diamonddetails?.id,
                "temp_cart_id": product[0]?.temp_cart_id,

            }
        )

        try {
            postdata = { "diamond_ids": details, cart_ids: cartids }
            let res = await _Api(postdata, `order/getCartDetails`)
            if (res?.statusCode === 200) {
                if (res?.data) {
                    console.log(res?.data, "check this")
                    let array = [...res?.data];
                    array?.forEach((result) => {
                        result.qty = parseInt(localitem.filter(e => e?.id === result?.id)[0]['qty']);
                    })
                    console.log(array, "find array")
                    setNotifycartitems(array);
                    
                }
                setLoading(false)
                if (res?.deleted_ids?.length) {
                    localitem.forEach((result) => {
                        if (!res?.deleted_ids.includes(result?.id)) {
                            let data = []
                            data.push(result)
                            localStorage.setItem('CartItems', JSON.stringify(data));
                        }
                    })
                }
            }
            setLoading(false)
        }
        catch (err) {
            setLoading(false)
            console.log(err, "err")
        }
    }
    const gotocheckout = () => {
        let checkoutitemarray = [];
        let array = [...notifycartitems];
        checkoutitemarray.push({ 'id': array[0]?.id, temp_cart_id: array[0]?.temp_cart_id, diamond_id: array[0]?.diamond?.id, 'qty': array[0]?.qty, 'price': array[0]?.UnFormatPrice })
        setCheckoutItems(checkoutitemarray);
        if (checkoutitemarray?.length) {
            navigate("/shipping", { state: { checkoutItems: checkoutitemarray } })
        }
    }
    useEffect(() => {
        if (isopennotifycart) {
            getcartItems();
        }
        // eslint-disable-next-line
    }, [isopennotifycart])
  return (
    <>
            <div onClick={() => setIsopennotifycart(false)} className="customize_modal" id="cartN">
                <div className="customize_modal-modalBox tempthreecartnotify">
                    <div className="customize_modal-modalBox-content">
                        <div className="customize_modal-modalBox-content-headBox">
                            <div className="customize_modal-modalBox-content-headBox-addToCartBox"><span></span>{t("Added to cart")}</div>
                            <span className="close" onClick={() => setIsopennotifycart(false)}><CrossIcon width={'16.71px'} height={'16.71px'} /></span>
                        </div>
                        {loading ? (<div style={{ marginTop: '5px', marginBottom: '5px' }}>

                            <Spinner />

                        </div>) : (
                            <>

                                {notifycartitems?.length ?
                                    notifycartitems.map((result, key) => {
                                        
                                        return (
                                            <>
                                                <div key={key} className={`ecom_cartproduct`}>
                                                    <div className="ecom_cartproduct-imageBox customize_modal-modalBox-content-bodyBox-imgBox">
                                                        <span className="product-img-span">
                                                            <img src={result?.main_image} alt="" />
                                                        </span>
                                                    </div>
                                                    <div className=" ecom_cartproduct-detailsBox">
                                                        <div className="ecom_cartproduct-detailsBox-firstBox">
                                                            <p className="ecom_cartproduct-detailsBox-firstBox-productName">
                                                                {result?.name}
                                                            </p>
                                                            <div className="ecom_cartproduct-detailsBox-firstBox-instock">{t("In Stock")}</div>
                                                            <div className="ecom_cartproduct-detailsBox-firstBox-colorthemewrapper">
                                                                { (result?.Metal === '18KBK' || result?.Metal.includes('BK')) && <div className={`black`}></div>}
                                                                { (result?.Metal === '18KWG' || result?.Metal.includes('WG')) && <><div className={`titanium`}></div><span className="ecom_cartproduct-detailsBox-firstBox-colorthemewrapper-title">{t("Sliver")}</span></>}
                                                                { (result?.Metal === '18KYG' || result?.Metal.includes('YG')) && <div className={`sunshine`}></div>}
                                                                { (result?.Metal === '18KRG' || result?.Metal.includes('RG')) && <div className={`peach`}></div>}
                                                            </div>
                                                            <div className="ecom_cartproduct-detailsBox-firstBox-content">
                                                                <p className="contentPara">{t("Size")}: {result?.Size}</p>
                                                                <div className="ecom_cartproduct-detailsBox-firstBox-price">{result?.price}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {result?.diamond ?

                                                    <div key={key} className="ecom_cartproduct">
                                                        <div className="ecom_cartproduct-imageBox customize_modal-modalBox-content-bodyBox-imgBox">
                                                            <span className="product-img-span">
                                                                <img src={result?.diamond?.main_image} alt="" />
                                                            </span>
                                                        </div>
                                                        <div className=" ecom_cartproduct-detailsBox">
                                                            <div className="ecom_cartproduct-detailsBox-firstBox">
                                                                <p className="ecom_cartproduct-detailsBox-firstBox-productName">
                                                                    {result?.diamond?.name}
                                                                </p>
                                                                <div className="ecom_cartproduct-detailsBox-firstBox-instock">{t("In Stock")}</div>
                                                                <div className="ecom_cartproduct-detailsBox-firstBox-content d-flex gap-1 flex-column">
                                                                    <p className="contentPara">{result?.diamond?.Colour} {t("Colour")} / {result?.diamond?.Cutlet} {result?.diamond?.Clarity} {result?.diamond?.Shape} {result?.diamond?.Cut} </p>
                                                                    <p className="ecom_cartproduct-detailsBox-firstBox-price">{result?.diamond?.price}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    : ""}
                                            </>
                                        )
                                    })
                                    : ""}
                            </>
                        )}


                        <div style={{ marginTop: '0' }} className="customize_modal-modalBox-content-footerBox">
                            <div className="customize_modal-modalBox-content-footerBox-wrapper">
                                <button className='btnwithborder roundbtn w-100' data-bs-toggle="modal" data-bs-target="#AddToCartModal" onClick={() => { setisopencart(true); setIsopennotifycart(false) }}> {t("View Cart")} ({localitem?.length})</button>
                                <button onClick={gotocheckout} className='btnbold roundbtn' disabled={notifycartitems?.length ? false : true}>{t("Checkout")}</button>
                            </div>
                            <div className="customize_modal-modalBox-content-footerBox-continueShoppLink">
                                <Link to="/"><button className=' customize_modal-modalBox-content-footerBox-continueShoppLink-btnShow'>{t("Continue Shopping")}</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
  )
}
